import React from 'react';
import '../assets/css/ProfileStatus.css';

const AttendanceStatus = ({
  label,
  number,          
  compare,          
  icon,
  bgColor = '#fff', 
  iconColor = '#000', 
  widths = '250px', 
  onClick // <-- new prop
}) => {


  
  return (
    <div
      className="progress-card col-sm-2"
      style={{
        backgroundColor: bgColor,
        width: widths,
        borderRadius: '12px',
        padding: '15px'
      }}
    >
      <div style={{ display: "flex", alignItems: 'center' }}>
        {/* icon */}
        <div
          style={{
            height: '50px',
            width: '50px',
            borderRadius: '22px',
            display: 'flex',
            alignItems: 'center',
            background: 'transparent',
            justifyContent: 'center',
            marginRight: "20px",
            boxShadow: '0 0 5px rgba(0,0,0,0.05)'
          }}
        >
          <img src={icon} alt={label} className="progress-card-icon" />
        </div>

        {/* right text */}
        <div className="progress-card-label">
          <p 
            className='m-0' 
            style={{ color: iconColor, fontSize: '30px', fontWeight: '500', cursor: 'pointer',textDecoration: 'underline' }}
            onClick={onClick} // clickable number
          >
            {number}
          </p>
          <p className='m-0' style={{ color: iconColor, fontSize: '14px', fontWeight: '500' }}>
            {label}
          </p>

          {compare && (
            <p className='m-0' style={{ color: iconColor, fontSize: '12px' }}>
              {compare}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendanceStatus;
